import React, { useEffect, useState } from 'react'
import { getAllCustomEvents } from '../../../../../redux/api/bookings.api'
import TourBookingsTable from './TourBookingsTable'

import './styles.scss'

const CustomEventBookings = () => {
    const [tourBookings, setTourBookings] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        handleFetchTourBookings()
    }, [])

    const handleFetchTourBookings = async () => {
        setLoading(true)
        const response = await getAllCustomEvents()
        if (response.status === 200) {
            setTourBookings(response.data)
        }
        setLoading(false)
    }

    return (
        <div className='tour_bookings'>
            <h1>
                Custom Event Bookings
            </h1>
            <div className='tour_bookings_table'>
                <TourBookingsTable
                    tourBookings={tourBookings}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default CustomEventBookings